import { ConditionalStrategy, Strategy } from 'utility-ts-strategy';

export interface IQuerySetResult {
  result: { length: number };
  has_more: boolean;
}

export const NO_RESULTS = 'There are no results for your search. Refine your search for better results.',
  ONE_RESULT = '1 result was found.',
  SOME_RESULTS = 'results were found.',
  MORE_RESULTS = 'Your search is limited to 20 results, add more text to narrow it down.';

export const ResultMessageStrategy = new Strategy({
  [NO_RESULTS]: (querySet: IQuerySetResult) => NO_RESULTS,
  [ONE_RESULT]: (querySet: IQuerySetResult) => ONE_RESULT,
  [SOME_RESULTS]: (querySet: IQuerySetResult) => `${querySet.result.length} ` + SOME_RESULTS,
  [MORE_RESULTS]: (querySet: IQuerySetResult) => MORE_RESULTS
});

export const ResultSelectionStrategy = new ConditionalStrategy({
  [NO_RESULTS]: (querySet: IQuerySetResult) => _.isEmpty(querySet.result),
  [ONE_RESULT]: (querySet: IQuerySetResult) => querySet.result.length === 1,
  [SOME_RESULTS]: (querySet: IQuerySetResult) => !querySet.has_more && querySet.result.length > 1,
  [MORE_RESULTS]: (querySet: IQuerySetResult) => querySet.has_more
});

export function getSearchResultsMessage(querySet: IQuerySetResult): string {
  return ResultMessageStrategy.get(ResultSelectionStrategy.evaluate(querySet))(querySet);
}



// WEBPACK FOOTER //
// ./app/lib/global/strategies/search_results_strategy.ts